<template>
  <div id="app" class="aabbcc">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
    <load></load>
    <tips></tips>

    <remote-script src="/apiChat/lib/signalr/dist/browser/signalr.min.js"></remote-script>
    <remote-script src="/apiChat/js/chat.js?v=5"></remote-script>
  </div>
</template>

<script>
import Vue from "vue";
import { getGlobalCities } from "@/api/m/shootCity";
import tips from "@/components/common/tips";
import load from "@/components/common/loading";
import { GetWechatAuthUrl } from "@/utils/common";
import Cookies from "js-cookie";
import { Notify, Toast } from "vant";
export default {
  name: "App",
  data() {
    return {
      openid: ""
    }
  },
  created() {
    let that = this;
    that.openid = Cookies.get("openid");
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {      
      if (!that.openid) {
        that.redirectToWeixin();
      }
    }

    window.ReceiveMessageFunc = function(fromUserId, message, userInfo) {
      console.info("接收到实时消息", fromUserId, message, JSON.parse(userInfo));
      //Toast(`您有新的消息\n${JSON.parse(userInfo).UserName}：${message}`);
      Notify.clear();
      that.$notify({
        message: `您有新的消息\n${JSON.parse(userInfo).UserName}：${message}`,
        duration: 0,
        background: "#C59753",
        onClick: function() {
          Notify.clear();
          console.info("点击进入聊天页面");
          that.$router.replace({
            path: "/Store/userChat?fromUserId=" + fromUserId
          });
          if (window.showChatWindow)
            window.showChatWindow(fromUserId, message, userInfo);
        }
      });
    };
    that.GetAreaDataList();
  },
  methods: {
    //获取所有区域数据
    GetAreaDataList: function() {
      let self = this;
      var storage = window.sessionStorage;
      let cityData = JSON.parse(storage.getItem("AllCityData"));
      if (!cityData) {
        getGlobalCities().then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            storage.setItem("AllCityData", JSON.stringify(data));
          }
        });
      }
    },
    //跳转到微信网页授权
    redirectToWeixin() {
      const url = `${window.location.origin + window.location.pathname}`;
      window.location.href = GetWechatAuthUrl(url);
    }
  },
  watch: {
    // 利用watch方法检测路由变化：
    $route: function(to, from) {
      document.activeElement.blur();
    }
  },
  data() {
    return {
      msg: "外壳"
    };
  },
  components: { tips, load }
};
Vue.component("remote-script", {
  render: function(createElement) {
    var self = this;
    return createElement("script", {
      attrs: {
        type: "text/javascript",
        src: this.src
      },
      on: {
        load: function(event) {
          self.$emit("load", event);
        },
        error: function(event) {
          self.$emit("error", event);
        },
        readystatechange: function(event) {
          if (this.readyState == "complete") {
            self.$emit("load", event);
          }
        }
      }
    });
  },

  props: {
    src: {
      type: String,
      required: true
    }
  }
});
</script>

<style lang='less'>
@import "assets/less/reset.less";
@import "assets/less/common.less";
@import "assets/less/mixin.less";
// @font-face {
//   font-family: "PingFang-SC-Bold";
//   src: url("assets/font/PingFang-SC-Bold.ttf") format("truetype");
//   /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
// }

// @font-face {
//   font-family: "PingFang-SC-Medium";
//   src: url("assets/font/PingFang-SC-Medium.ttf") format("truetype");
//   /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
// }
#app {
  font-family: "PingFang-SC-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  height: 100%;
  // min-height: 100%;
  // width: 100%;
  overflow-x: hidden;
  background: #fff;
}
.swiper-container-vertical > .swiper-pagination-progressbar,
.swiper-container-horizontal
  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  left: auto;
  right: 0;
  background: @blue;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: @red;
  box-shadow: 0 0 5px @white;
}
// 进度条
.van-steps {
}
.van-step--finish {
  color: rgb(51, 204, 255);
}
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: rgb(51, 204, 255, 0.3);
}
// 单选
.van-radio-group {
  display: flex;
  justify-content: flex-end;
}
.van-radio {
  margin-left: 0.3rem;
}
// 解决无法滑动的问题
.van-picker-column {
  position: relative;
  z-index: 1;
  &::before {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
  }
  & > ul {
    z-index: -1;
    position: relative;
  }
}

// 确认取消按钮的定位在底部
.handle-dialog {
  .van-hairline--top {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    .van-dialog__confirm {
      background: #1989fa;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue